import r from "./_getLength.js";
import { slice as t } from "./_setup.js";
import e from "./isNaN.js";
function n(n, f, i) {
  return function (o, u, a) {
    var m = 0,
      s = r(o);
    if ("number" == typeof a) n > 0 ? m = a >= 0 ? a : Math.max(a + s, m) : s = a >= 0 ? Math.min(a + 1, s) : a + s + 1;else if (i && a && s) return a = i(o, u), o[a] === u ? a : -1;
    if (u != u) return (a = f(t.call(o, m, s), e)) >= 0 ? a + m : -1;
    for (a = n > 0 ? m : s - 1; a >= 0 && a < s; a += n) if (o[a] === u) return a;
    return -1;
  };
}
export { n as default };